import React from "react";
import * as R from "ramda";
import * as Yup from "yup";
import { connect } from "react-redux";
import { compose } from "recompose";
import { withTranslation } from "react-i18next";
import { Formik, Form } from "formik";
import { isLoading } from "@worcket/common/hocs";

import {
  updateCompanyProfile,
  UPDATE_COMPANY_PROFILE
} from "../../store/actions/company";
import {
  updateHeadquarterProfile,
  UPDATE_HEADQUARTER_PROFILE
} from "../../store/actions/headquarter";
import { fetchUniversities } from "../../store/actions/catalogs";
import Button from "../../components/Button";
import { ACCEPT_LANGUAGE } from "../../locales/acceptedLanguages";

import ProfileFormInputs from "./ProfileFormInputs";

const ProfileForm = ({ profile, loading, onSubmit, t }) => {
  const emptyFieldValidation = Yup.string().required(
    t("form:emptyFieldValidation")
  );
  const urlValidation = Yup.string().matches(
    /^((https?|ftp|smtp):\/\/)?(www.)?([a-z0-9]+)(\.[a-z]{2,}){1,3}(#?\/?[a-zA-Z0-9-_#&().]+)*\/?\??([a-zA-Z0-9-_]+(=[a-zA-Z0-9-%]+&?)?)*$/,
    t("form:urlValidation")
  );

  const profileFormValidation = Yup.object().shape({
    name: emptyFieldValidation,
    country: emptyFieldValidation,
    address: emptyFieldValidation,
    website: urlValidation,
    tyc: urlValidation
  });

  return (
    <Formik
      initialValues={R.pick(
        [
          "name",
          "country",
          "language",
          "logo",
          "address",
          "description",
          "slogan",
          "website",
          "industry",
          "tyc"
        ],
        profile
      )}
      onSubmit={values =>
        onSubmit({
          companyId: profile.id,
          formData: R.dissoc("name", values)
        })
      }
      validationSchema={profileFormValidation}
    >
      {({ handleSubmit, values, setFieldValue }) => (
        <Form
          data-test="company-profile-form"
          layout="vertical"
          onSubmit={handleSubmit}
        >
          <ProfileFormInputs
            values={values}
            isNewCompany={false}
            isHeadquarter={profile.isHeadquarter}
            setFieldValue={setFieldValue}
          />
          <div
            style={{
              display: "flex",
              justifyContent: "flex-end",
              width: "100%"
            }}
          >
            <Button
              loading={loading}
              type="primary"
              size="lg"
              htmlType="submit"
            >
              {t("global:save")}
            </Button>
          </div>
        </Form>
      )}
    </Formik>
  );
};

const enhancer = compose(
  withTranslation(["global", "form", "company"]),
  connect(
    undefined,
    (dispatch, { profile }) => ({
      onSubmit: props => {
        const newCountry = R.pathOr(
          profile.country,
          ["formData", "country"],
          props
        );

        props.formData.language =
          ACCEPT_LANGUAGE[newCountry] ||
          profile.language ||
          ACCEPT_LANGUAGE.DEFAULT;

        if (profile.isHeadquarter) {
          return dispatch(updateHeadquarterProfile(props));
        } else {
          dispatch(updateCompanyProfile(props));

          if (profile.country !== newCountry) {
            dispatch(fetchUniversities(newCountry));
          }
        }
      }
    })
  ),
  isLoading([UPDATE_HEADQUARTER_PROFILE, UPDATE_COMPANY_PROFILE])
);

export default enhancer(ProfileForm);
